import Module from './Module';
import Viewport from '../../Viewport';
import * as log from 'loglevel';

/**
 * This module enables the Viewport on Bootstrap life-cycle.
 * 
 * @extends Module
 * @category bootstrap
 * @author Geoffrey Mayeux
 */
class ViewportModule extends Module{
	constructor(bootstrap){
		super(bootstrap);
		this.viewport 	= new Viewport();
	}

	async after(){
		await this.viewport.resize();
	}
}

export default ViewportModule;
export { ViewportModule };